import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import BrandList from "./brandList";
import { getBrandsApi } from "../../../api/brand";
import { AddEditBrand } from "./AddEditBrand";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Brand = () => {
  const [openBrand, setOpenBrand] = useState(false);
  const [paginatedBrand, setPaginatedBrand] = useState<any>();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");
  const resetFilters = () => {
    getBrands({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedBrand(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getBrands({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedBrand(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getBrands({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedBrand(res.data);
    });
  };

  const getBrands = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await BrandsMutation(params);
  };

  const { mutateAsync: BrandsMutation, isLoading: isBrandsLoading } =
    useMutation("brands", getBrandsApi);
  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenBrand(true)} />
        </Col>
        <Col span={24} className="">
          <BrandList
            tableKey={tableKey}
            paginatedBrand={paginatedBrand}
            setPaginatedBrand={setPaginatedBrand}
            BrandsMutation={BrandsMutation}
            filter={filter}
            search={search}
            page={page}
            setPage={setPage}
            isBrandsLoading={isBrandsLoading}
          />
        </Col>
      </Row>
      {openBrand && (
        <AddEditBrand
          setOpenBrand={setOpenBrand}
          openBrand={openBrand}
          setPaginatedBrand={setPaginatedBrand}
          BrandsMutation={BrandsMutation}
          filter={filter}
          search={search}
          page={page}
        />
      )}
    </>
  );
};

export default Brand;
